import dayjs from "dayjs";
import $thousandMask from "@/mixins/thousandMask";

export default {
  name: "withdraw-crypto-detail",
  components: {},
  props: {
    data: Object,
    orderDetails: Object
  },
  mixins: [$thousandMask],
  data() {
    return {
      isLegal: this.$cookies.get("CA_ID")
    };
  },
  filters: {
    formatDate(date) {
      let format =
        localStorage.getItem("lang") === "fa"
          ? "YYYY/MM/DD - HH:mm"
          : "YYYY/DD/MM - HH:mm";

      return dayjs(date).format(format);
    }
  },
  computed: {},
  mounted() {},
  methods: {}
};
